export default "__VITE_ASSET__bb983898__"